import React from "react";


export default function Loader() {
  return (<div className="progress">
  <div className="indeterminate"></div>
</div>);
}